import * as Sentry from '@sentry/react';

import { currentProfileId, currentShadowId, currentWorkspaceId, getMetaContent } from './meta';

/**
 * Initialize Sentry if not already initialized and DSN is available
 */
export const initSentry = () => {
  if (Sentry.isInitialized() || !getMetaContent('sentry:dsn')) return;

  const ignoreErrors = [
    'TypeError: Failed to fetch',
    'TypeError: Load failed',
    'TypeError: NetworkError when attempting to fetch resource.',
    'AbortError: The user aborted a request.',
    'AbortError: Fetch is aborted',
    'Error: invalid origin',
  ];

  // build the initial scope
  const initialScope = {};
  if (currentProfileId()) initialScope.user = { ...(initialScope?.user || {}), id: `profile_${currentProfileId()}` };
  if (currentShadowId()) initialScope.user = { ...(initialScope?.user || {}), id: `shadow_${currentShadowId()}` };
  if (currentWorkspaceId()) initialScope.tags = { ...(initialScope?.tags || {}), workspace_id: currentWorkspaceId() };

  Sentry.init({
    dsn: getMetaContent('sentry:dsn'),
    release: getMetaContent('sentry:release'),
    environment: getMetaContent('sentry:environment'),
    tracesSampleRate: parseFloat(getMetaContent('sentry:traces_sample_rate') || '0.0'),
    replaysOnErrorSampleRate: 1.0,
    normalizeDepth: 5,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    ignoreErrors,
    initialScope,
  });
};
